import { type I18n } from 'vue-i18n';

import { initI18n, LocaleFileSuffix } from './i18n-setup';
import translations from './i18n/de-hg';

export function createI18n(): I18n {
  return initI18n(translations, LocaleFileSuffix.HG);
}
